export default __webpack_public_path__ + "static/media/h_wdt_c_5.dabf25a2.mp3";